import * as React from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

import { PageTitle } from '../pages/pageTitle';

import { DataRequestActionTypes } from 'constants/actionTypes';
import * as PermissionsHelper from 'helpers/permissionsHelper';
import { EventsTableColumns } from './eventsTable';
import CreateEventForm from './createEventForm';
import { ActiveEventsTableContainer } from './eventsTableActiveContainer';
import { ArchivedEventsTableContainer } from './eventsTableArchivedContainer';

const ActiveEventsTableColumns = [
  EventsTableColumns.ClientName,
  EventsTableColumns.EventName,
  EventsTableColumns.EventType,
  EventsTableColumns.EventStart,
  EventsTableColumns.EventReadyEstimate,
  EventsTableColumns.Assignee,
  EventsTableColumns.Status,
  EventsTableColumns.TotalParticipants,
  EventsTableColumns.ParticipantsWithClipsGenerated,
  EventsTableColumns.ClipGenerationErrors,
];

const ArchivedEventsTableColumns = [
  EventsTableColumns.ClientName,
  EventsTableColumns.EventName,
  EventsTableColumns.EventType,
  EventsTableColumns.EventStart,
  EventsTableColumns.EventReadyEstimate,
  EventsTableColumns.Assignee,
  EventsTableColumns.Status,
];

// eslint-disable-next-line react/prefer-stateless-function
export class EventsPage extends React.Component {
  public render() {
    return (
      <>
        <PageTitle displayTitle="Events">
          {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.CreateEvent) && (
            // @ts-ignore
            <CreateEventForm submitActionType={DataRequestActionTypes.CreateEventRequested} />
          )}
        </PageTitle>
        <Tabs>
          <TabList>
            <Tab>Active events</Tab>
            <Tab>Archived events</Tab>
          </TabList>
          <TabPanel>
            <ActiveEventsTableContainer columns={ActiveEventsTableColumns} />
          </TabPanel>
          <TabPanel>
            <ArchivedEventsTableContainer columns={ArchivedEventsTableColumns} archived />
          </TabPanel>
        </Tabs>
      </>
    );
  }
}
